import React from 'react';

import '../Button/MultipleAccountsButton.less';

const MultipleAccountsButton = ({
    brandImage,
    flagImage,
    language,
    domain,
    currencies,
    selectAccount,
    buttonId,
    enableButton
}) => {
    return (
        <button 
            className="multiple-accounts-button"
            type="submit"
            id={buttonId} 
            onClick={selectAccount}
            disabled={!enableButton}
        >
            <div className="brand-section">
                <img className="brand-logo" src={brandImage} />
                <div className="domain">{domain}</div>
            </div>
            <div className="vertical-divider"/>

            <div className="language-section">
                <span className="language-label">{'Language'}</span>
                <div className="language-content">
                    <img className="language-flag" src={flagImage}/>
                    <span className="language-text">{language}</span>
                </div>
            </div>

            <div className="currency-section">
                <span className="currency-label">{'Currency'}</span>
                <span className="currency-text">{currencies}</span>
            </div>
        </button>
    );
}

export default MultipleAccountsButton;